import Reflux from "reflux";

export default Reflux.createActions({
  startDragging: {},
  stopDragging: {},
  loadExtensions: {}
});
